import { render, staticRenderFns } from "./studentLow.vue?vue&type=template&id=be59c6d4&scoped=true&"
import script from "./studentLow.vue?vue&type=script&lang=js&"
export * from "./studentLow.vue?vue&type=script&lang=js&"
import style0 from "./studentLow.vue?vue&type=style&index=0&id=be59c6d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be59c6d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
